<template>
  <div id="jianerkang-app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'jianerkang-app'
}
</script>
